<template>
  <div class="sw-grid-flex sw-grid-flex--dir-column">
    <div class="sw-grid-flex sw-grid-flex--wrap sw-grid-flex--align-center">
      <div v-for="item in manufacturers" :key="'manufacturer-' + item.id"
           class="sw-grid-flex__cell-1-4 sw--padding-2">
        <input
          :disabled="!materialId"
          type="checkbox"
          :id="item.id"
          :value="item.id"
          v-model="selectedManufacturers">
        <label
          :for="item.id"
          :class="!materialId ? 'sw-dms--color-grey-64' : ''">{{item.name}}
        </label>
      </div>
      <bottom-banner
        :missing-info="missingInformation"
        v-on:saved="saveManufacturers"
        :show-saved-message="showSavedMessage" />
      <div v-if="missingInformation.length <= 0" class="sw-grid-flex__cell-1-1 sw--padding-vert-2">
        <button
          v-if="allSelected"
          @click="unselectAll"
          class="sw-dms-button sw-dms-button--big sw--float-right sw--cursor-pointer">
          Unselect All
        </button>
        <button
          v-else
          @click="selectAll"
          class="sw-dms-button sw-dms-button--big sw--float-right sw--cursor-pointer">
          Select All
        </button>
      </div>
    </div>
  </div>
</template>

<script>
    import VueJQueryMixin from 'js/lib/vue/mixins/vue-jquery-mixin';
    import VueSwMixin from 'js/lib/vue/mixins/vue-sw-mixin';
    import BottomBanner from "rrViewComponents/Inshape/Admin/Materials/AddMaterial/BottomBannerComponent/bottom-banner";

    export default {
        name: "material-manufacturers",
        components: {BottomBanner},
        mixins: [VueSwMixin, VueJQueryMixin],
        props: {
            manufacturers: {
                type: Array,
                required: true,
            },
            materialId: {
                type: Number,
                required: false
            },
            printerTechnologyIds: {
                type: Array,
                required: false
            },
            currentMaterial: {
                type: Object,
                default: () => ({})
            }
        },
        created() {
            if(this.currentMaterial) {
              this.selectedManufacturers = this.currentMaterial.manufacturerIds;
            }
        },
        data: () => ({
            selectedManufacturers: [],
            showSavedMessage: false
        }),
        computed: {
            allSelected() {
                return this.selectedManufacturers.length === this.manufacturers.length;
            },
            missingInformation() {
                let missingInfo = [];
                if (!this.materialId) {
                    missingInfo.push('Basic Information')
                };
                if (!this.printerTechnologyIds || this.printerTechnologyIds.length <= 0) {
                    missingInfo.push('Printers')
                }
                return missingInfo;
            }
        },
        methods: {
            selectAll() {
                this.selectedManufacturers = [];
                this.manufacturers.forEach(item => {
                    this.selectedManufacturers.push(item.id)
                });
                return this.selectedManufacturers;
            },
            unselectAll() {
                return this.selectedManufacturers = [];
            },
            saveManufacturers() {
                let _this = this;
                this.$jQuery.ajax({
                    type: 'POST',
                    url: '/admin/material/' + _this.materialId + '/manufacturers',
                    dataType: 'json',
                    data: { manufacturers : _this.selectedManufacturers },
                    success: (data) => {
                        _this.$emit('success', data);
                        _this.showSavedMessage = true;
                        this.$sw.notifications.success('Saved!')
                    },
                    error: (jqXHR) => {
                        const response = JSON.parse(jqXHR.responseText);
                        _this.errorMessage = response.message;
                        _this.$emit('error', jqXHR);
                    }
                });
            }
        }
    }
</script>
